import { render, staticRenderFns } from "./BIMApplication.vue?vue&type=template&id=123c0e5a&scoped=true&"
import script from "./BIMApplication.vue?vue&type=script&lang=js&"
export * from "./BIMApplication.vue?vue&type=script&lang=js&"
import style0 from "./BIMApplication.vue?vue&type=style&index=0&id=123c0e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c0e5a",
  null
  
)

export default component.exports